/**
 * @generated SignedSource<<8075553e86a64e602289ee99f82c7e21>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type Locale = "EN" | "LT";
import { FragmentRefs } from "relay-runtime";
export type useTranslatableField_text$data = {
  readonly translations: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly locale: Locale;
        readonly string: string | null;
      };
    }>;
  };
  readonly " $fragmentType": "useTranslatableField_text";
};
export type useTranslatableField_text$key = {
  readonly " $data"?: useTranslatableField_text$data;
  readonly " $fragmentSpreads": FragmentRefs<"useTranslatableField_text">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useTranslatableField_text",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TextTranslationConnection",
      "kind": "LinkedField",
      "name": "translations",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TextTranslationEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "TextTranslation",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "locale",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "string",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Text",
  "abstractKey": null
};

(node as any).hash = "e8408f2fe77408706f38e5fe364058fd";

export default node;
